import axios from "axios";
import { params, header, findingRuleAPI, findingFieldAPI } from "../_api";

import {
  FETCH_SELECT_FINDING_RULE_SUCCESS,
  FETCH_SELECT_FINDING_RULE_FAILURE,
  CREATE_NEW_FINDING_RULE_SUCCESS,
  CREATE_NEW_FINDING_RULE_FAILURE,
  FETCH_SCOPED_FINDING_RULE_TO_DELETE_SUCCESS,
  FETCH_SCOPED_FINDING_RULE_TO_DELETE_FAILURE,
  EDIT_FINDING_RULE_SUCCESS,
  EDIT_FINDING_RULE_FAILURE,
  DELETE_FINDING_RULE_SUCCESS,
  DELETE_FINDING_RULE_FAILURE,
  FETCH_SELECT_FINDING_FIELD_SUCCESS,
  FETCH_SELECT_FINDING_FIELD_FAILURE,
  FETCH_FINDING_RULE_REQUEST,
  FETCH_EDIT_FINDING_FIELD_SUCCESS,
  FETCH_EDIT_FINDING_FIELD_FAILURE,
} from "../_constants";

const fetchSelectFindingRuleRequest = () => {
  return { type: FETCH_FINDING_RULE_REQUEST };
};

const fetchSelectFindingRuleSuccess = (data) => {
  return { type: FETCH_SELECT_FINDING_RULE_SUCCESS, payload: data };
};

const fetchSelectFindingRuleFailure = (error) => {
  return { type: FETCH_SELECT_FINDING_RULE_FAILURE, payload: error };
};

export const fetchSelectFindingRule = (id=null, machine_type,hmi_type) => {
  return async (dispatch) => {
    dispatch(fetchSelectFindingRuleRequest())
    return axios({
      method: "get",
      url: findingRuleAPI+(id?`${id}/`:''),
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId'),
        with_findings_completed_info: true
      },
      headers: header,
      })
      .then((response) => {
        dispatch(fetchSelectFindingRuleSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchSelectFindingRuleFailure(errorMsg));
      });
  };
};

const fetchScopedFindingRuleToDeleteSuccess = (data) => {
  return { type: FETCH_SCOPED_FINDING_RULE_TO_DELETE_SUCCESS, payload: data };
};

const fetchScopedFindingRuleToDeleteFailure = (error) => {
  return { type: FETCH_SCOPED_FINDING_RULE_TO_DELETE_FAILURE, payload: error };
};

export const fetchScopedFindingRuleToDelete = (findingRuleId,machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: findingRuleAPI + findingRuleId +"/",
      params: {
        ...params,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchScopedFindingRuleToDeleteSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchScopedFindingRuleToDeleteFailure(errorMsg));
      });
  };
};

const createNewFindingRuleSuccess = (data) => {
  return { type: CREATE_NEW_FINDING_RULE_SUCCESS, payload: data };
};

const createNewFindingRuleFailure = (error) => {
  return { type: CREATE_NEW_FINDING_RULE_FAILURE, payload: error };
};

export const createNewFindingRule = (body, handleCreateFindingRule, machine_type,hmi_type) => {  
  return async (dispatch) => {
    return axios({
      method: "POST",
      url: findingRuleAPI,
      params: {
        ...params,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: body,
    })
      .then((response) => {
        dispatch(createNewFindingRuleSuccess(response.data));
        handleCreateFindingRule(response.data);
        dispatch(fetchSelectFindingRule(null,machine_type,hmi_type));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        handleCreateFindingRule(false);
        dispatch(createNewFindingRuleFailure(errorMsg));
      });
  };
};

const editFindingRuleSuccess = (data) => {
  return { type: EDIT_FINDING_RULE_SUCCESS, payload: data };
};

const editFindingRuleFailure = (error) => {
  return { type: EDIT_FINDING_RULE_FAILURE, payload: error };
};

export const editFindingRule = (findingRuleId, body,machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "put",
      url: findingRuleAPI + findingRuleId+"/",
      params: {
        ...params,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: body,
    })
      .then((response) => {
        dispatch(editFindingRuleSuccess(response.data));
        if(body.finding_field_id){
          dispatch(fetchSelectFindingRule(findingRuleId,machine_type,hmi_type));
        } else {
          dispatch(fetchSelectFindingRule(null,machine_type,hmi_type));
        }
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(editFindingRuleFailure(errorMsg));
      });
  };
};

const deleteFindingRuleSuccess = (data) => {
  return { type: DELETE_FINDING_RULE_SUCCESS, payload: data };
};

const deleteFindingRuleFailure = (error) => {
  return { type: DELETE_FINDING_RULE_FAILURE, payload: error };
};

export const deleteFindingRule = (findingRuleId, handleDeleteFindingRule, machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "DELETE",
      url: findingRuleAPI + findingRuleId +"/",
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(deleteFindingRuleSuccess(response.data));
        handleDeleteFindingRule(true);
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        handleDeleteFindingRule(false);
        dispatch(deleteFindingRuleFailure(errorMsg));
      });
  };
};

const fetchFindingFieldSuccess = (data) => {
  return { type: FETCH_SELECT_FINDING_FIELD_SUCCESS, payload: data };
};

const fetchFindingFieldFailure = (error) => {
  return { type: FETCH_SELECT_FINDING_FIELD_FAILURE, payload: error };
};

export const fetchFindingField = (machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: findingFieldAPI,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchFindingFieldSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchFindingFieldFailure(errorMsg));
      });
  };
};

